<script>
  import { getDriverAreaTree } from '@/api/vehicle/vehicle-manage'
  import BannerPreview from './BannerPreview.vue'
  import banner2 from './bannerTemplate/banner2.vue'
  import banner3 from './bannerTemplate/banner3.vue'
  import banner4 from './bannerTemplate/banner4.vue'
  import banner1 from './bannerTemplate/banner1.vue'
  import AdGroupSelect from '@/components/AdGroupSelect/index.vue'
  import { getBannerTemList } from '@/api/bottomBannerDefault'
  import { editFooterBanner } from '@/api/footerBanner'
  import { advertisingLocation } from '@/api/marketing/advertising'
  import { getPageEnumList } from '../../../../api/marketing/advertising'

  export default {
    name: 'BannerEdit',
    components: { banner1, BannerPreview, banner2, banner3, banner4, AdGroupSelect },
    props: {
      title: {
        type: String,
        default: '新增banner'
      },
      visible: {
        type: Boolean,
        default: false
      },
      isEdit: {
        type: Boolean,
        default: false
      },
      editData: {
        type: Object,
        default: () => ({})
      },
      adGroupId: {
        type: [String, Number],
        default: ''
      },
      templateId: {
        type: [String, Number],
        default: ''
      },
      displayPageName: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        form: {
          id: undefined,
          name: '',
          sort: 1,
          adGroupId: null,
          startTime: '',
          endTime: '',
          allArea: 1,
          areaIdList: [],
          templateId: '',
          groupItem: {},
          slotKey: '',
          displayPage: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入广告名称', trigger: 'blur' },
            { max: 30, message: '不超过30个字', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('名称不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: ['blur', 'change']
            }
          ],
          sort: [
            { required: true, message: '请输入权重', trigger: ['blur', 'change'] },
            {
              pattern: /^(?:[1-9]|10)$/,
              message: '请输入小于等于10的正整数',
              trigger: ['blur', 'change']
            }
          ],
          adGroupId: [{ required: true, message: '请选择广告组', trigger: 'change' }],
          startTime: [{ required: true, message: '请选择展示时间', trigger: 'change' }],
          areaIdList: [{ required: true, message: '请选择展示地区', trigger: 'change' }],
          allArea: [{ required: true, message: '请选择展示地区', trigger: 'change' }],
          displayPage: [{ required: true, message: '请选择展示页面', trigger: 'change' }]
        },
        dateRange: [],
        getDriverAreaTree,
        slotKeys: [],
        bannerTemplates: [],
        locationKeyList: [],
        bannerGroupList: [
          {
            id: 1,
            name: '首页乘客底部广告组1',
            templateId: 1
          },
          {
            id: 2,
            name: '首页乘客底部广告组2',
            templateId: 1
          },
          {
            id: 3,
            name: '首页乘客底部广告组3',
            templateId: 2
          },
          {
            id: 4,
            name: '首页乘客底部广告组4',
            templateId: 3
          },
          {
            id: 5,
            name: '首页乘客底部广告组5',
            templateId: 4
          }
        ],
        pageEnumList: []
      }
    },
    created() {
      // 兼容后端接口调的
      advertisingLocation().then((res) => {
        const { data, code } = res
        if (code === 0) {
          this.locationKeyList = data
        }
      })
      getBannerTemList().then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.bannerTemplates = data.filter((item) => {
            return true
          })
          // 广告组配置是需要初始化的数据
          console.log('初始数据', this.adGroupId, this.templateId)
          getPageEnumList().then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.pageEnumList = data.bannerDisplayPage || []
              if (this.isEdit && this.editData) {
                this.initEditData()
              } else {
                if (this.adGroupId && this.templateId && this.displayPageName) {
                  this.form.adGroupId = this.adGroupId
                  this.adGroupChange({
                    templateId: this.templateId,
                    bannerDisplayPage: this.displayPageName
                  })
                }
              }
            }
          })
        }
      })
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        }
      },
      img() {
        const map = new Map([
          [1, require('@/assets/images/banner/banner1View.jpg')],
          [2, require('@/assets/images/banner/banner2View.jpg')],
          [3, require('@/assets/images/banner/banner3View.jpg')],
          [4, require('@/assets/images/banner/banner4View.jpg')]
        ])
        const { templateId } = this.form
        return map.get(templateId)
      }
    },
    methods: {
      fieldFormat(data) {
        data.forEach((item) => {
          item.children &&
            item.children.forEach((child) => {
              child.children = null
            })
        })
        const search = (list) => {
          for (let i = 0; i < list.length; i++) {
            const { children } = list[i]
            if (Array.isArray(children) && children.length > 0) {
              list[i].childAreaManage = children
              search(children)
            }
          }
        }

        search(data)
        return data
      },

      initEditData() {
        const channelMap = {
          微信小程序: '1',
          APP: '2',
          云闪付: '3',
          支付宝小程序: '4'
        }
        const { displayChannel, advertisingAreaVoList, displayPage, ...rest } = this.editData
        const displayChannelList = displayChannel.split('、').map((channel) => {
          // 如果是字符串标签，转换为数字ID
          return channelMap[channel] || channel
        })
        const pageItem = this.pageEnumList.find((item) => item.label === displayPage)
        this.form = {
          ...rest,
          adGroupId: rest.bannerGroupId,
          displayChannel: displayChannelList.join(','),
          areaIdList: advertisingAreaVoList ? advertisingAreaVoList.map((item) => item.id) : [],
          displayPage: pageItem ? pageItem.value : ''
        }

        console.log('this.form', JSON.parse(JSON.stringify(this.form)))

        const Template = this.bannerTemplates.find((item) => item.id === this.form.templateId)
        if (Template) {
          this.slotKeys = Template.slotKeys
          // this.form.slotKey = this.slotKeys[0] || ''
        }

        if (this.form.startTime && this.form.endTime) {
          this.dateRange = [this.form.startTime, this.form.endTime]
        }
      },

      beforeClose(done) {
        this.closeDialog(true, done)
      },

      closeDialog(hasConfirm = true, done) {
        if (hasConfirm) {
          this.$confirm('暂未保存内容，是否确认关闭?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              done && done()
              this.dialogVisible = false
            })
            .catch(() => {})
        } else {
          this.dialogVisible = false
        }
      },

      closeEdit() {
        this.closeDialog(true)
      },

      handleDateRangeChange(val) {
        if (val) {
          this.form.startTime = val[0]
          this.form.endTime = val[1]
        } else {
          this.form.startTime = ''
          this.form.endTime = ''
        }
      },

      pickerOptionStart() {
        return {
          disabledDate: (time) => {
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          }
        }
      },

      pickerOptionEnd() {
        if (!this.form.startTime) {
          return
        }
        return {
          disabledDate: (time) => {
            return time.getTime() < new Date(this.form.startTime).getTime() - 86400000
          }
        }
      },

      // 校验基本表单
      validateForm() {
        return new Promise((resolve, reject) => {
          this.$refs.bannerForm.validate((valid) => {
            if (valid) {
              resolve(this.form)
            } else {
              // 表单验证失败
              reject(new Error('基本信息表单验证失败'))
            }
          })
        })
      },

      handleSubmit() {
        // 先校验基本表单
        this.validateForm()
          .then(() => {
            // 然后校验banner组件中的所有表单
            if (this.$refs.banner) {
              return this.$refs.banner.validateAllForms(this.slotKeys)
            }
            return this.form
          })
          .then((formData) => {
            console.log('获取的数据', formData)
            // banner组件中设置了一个name字段，会覆盖，单独取出来使用
            const { name } = this.form
            // 处理表单数据
            let dataToSubmit

            // 如果使用Tab风格，需要处理所有位置的数据
            if (this.useTabStyle && formData.allPositionsData) {
              // 准备提交的数据数组
              const submitDataArray = []

              // 遍历所有位置数据
              for (const slotKey in formData.allPositionsData) {
                const positionData = formData.allPositionsData[slotKey]

                // 确保该位置有数据且有必要的字段
                if (positionData && positionData.imgUrl) {
                  // 确保核心字段不被覆盖
                  submitDataArray.push({
                    slotKey, // 确保slotKey正确
                    ...this.form,
                    ...positionData, // 该位置的特定数据
                    areaIdList: this.form.areaIdList.map((item) => item.at(-1)),
                    name
                  })
                }
              }

              dataToSubmit = submitDataArray
            } else {
              // 确保核心字段不被覆盖
              dataToSubmit = [
                {
                  ...this.form,
                  ...formData,
                  areaIdList: this.form.areaIdList.map((item) => item.at(-1)),
                  name
                }
              ]
            }

            console.log('dataToSubmit', dataToSubmit)

            if (!this.isEdit) {
              return editFooterBanner({
                ...dataToSubmit[0],
                clientType: 1,
                locationKey: this.locationKeyList[0]
                  ? this.locationKeyList[0].advertisingLocationKey
                  : ''
              })
            } else {
              return editFooterBanner({
                ...dataToSubmit[0],
                clientType: 1,
                locationKey: this.locationKeyList[0]
                  ? this.locationKeyList[0].advertisingLocationKey
                  : ''
              })
            }
          })
          .then((res) => {
            const { code } = res
            if (code === 0) {
              this.$message.success(this.isEdit ? '编辑banner成功！' : '新增banner成功！')
              this.$emit('success')
              this.closeDialog(false)
            }
          })
          .catch((error) => {
            this.$message.error(error.message || '操作失败')
            console.error('表单校验失败:', error)
          })
      },

      adGroupChange(val) {
        const page = this.pageEnumList.find((item) => item.label === val.bannerDisplayPage)
        if (page) {
          this.form.displayPage = page.value
        }
        this.form.templateId = val.templateId || ''
        const Template = this.bannerTemplates.find((item) => item.id === this.form.templateId)
        if (Template) {
          this.slotKeys = Template.slotKeys
          this.form.slotKey = this.slotKeys[0] || ''
        }
      }
    }
  }
</script>

<template>
  <yd-dialog
    :title="title"
    :visible="dialogVisible"
    width="1250px"
    @close="beforeClose"
    append-to-body
  >
    <div class="contain">
      <div class="left">
        <el-form ref="bannerForm" :model="form" :rules="rules" label-width="120px" size="small">
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入广告名称"
              maxlength="30"
              show-word-limit
              style="width: 400px"
              v-no-emoji
            />
          </el-form-item>

          <el-form-item label="权重" prop="sort">
            <div style="display: flex; align-items: center">
              <el-input-number v-model="form.sort" :min="1" :max="10" />
              <span class="form-tip" style="width: 450px"
                >（权重数值越小越靠前，banner优先级越高）</span
              >
            </div>
          </el-form-item>

          <el-form-item label="所属广告组" prop="adGroupId">
            <AdGroupSelect
              v-model="form.adGroupId"
              :multiple="false"
              required
              :label="false"
              :disabled="!!(adGroupId && templateId && displayPageName)"
              @select="adGroupChange"
            />
          </el-form-item>

          <el-form-item label="展示页面" prop="displayPage">
            <el-select
              v-model="form.displayPage"
              placeholder="请选择"
              clearable
              style="width: 300px"
              :disabled="true"
            >
              <el-option
                v-for="item in pageEnumList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="展示时间" required prop="startTime">
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="选择开始日期"
              end-placeholder="选择结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionStart()"
              @change="handleDateRangeChange"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 400px"
            />
          </el-form-item>

          <el-form-item label="展示地区" :prop="form.allArea === 1 ? 'allArea' : 'areaIdList'">
            <div>
              <el-radio-group v-model="form.allArea">
                <el-radio :label="1">全部地区</el-radio>
                <el-radio :label="0">部分地区</el-radio>
              </el-radio-group>
            </div>
            <YdCitySelect
              v-if="form.allArea !== 1"
              mode="2"
              placeholder="请选择地区"
              :customHttp="getDriverAreaTree"
              :fieldFormat="fieldFormat"
              v-model="form.areaIdList"
            />
          </el-form-item>
        </el-form>
        <banner1
          v-if="form.templateId === 1"
          v-model="form"
          :slotKeys="slotKeys"
          :useTabStyle="false"
          ref="banner"
          :isEdit="isEdit"
        />
        <banner2
          v-if="form.templateId === 2"
          v-model="form"
          :slotKeys="slotKeys"
          :useTabStyle="false"
          ref="banner"
          :isEdit="isEdit"
        />
        <banner3
          v-if="form.templateId === 3"
          v-model="form"
          :slotKeys="slotKeys"
          :useTabStyle="false"
          ref="banner"
          :isEdit="isEdit"
        />
        <banner4
          v-if="form.templateId === 4"
          v-model="form"
          :slotKeys="slotKeys"
          :useTabStyle="false"
          ref="banner"
          :isEdit="isEdit"
        />
      </div>
      <div class="right" v-if="form.templateId">
        <banner-preview>
          <template #imgSlot>
            <div class="preview-img-container">
              <img :src="img" alt="Banner预览" class="preview-img" />
            </div>
          </template>
        </banner-preview>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
  </yd-dialog>
</template>

<style scoped lang="scss">
  .contain {
    display: flex;
    .left {
      flex: 1;
    }

    .right {
      width: 500px;
      margin-left: 20px;
    }
  }

  .form-tip {
    font-size: 12px;
    color: red;
    line-height: 1.5;
    //margin-top: 5px;
  }

  .preview-img-container {
    width: 300px;
    .preview-img {
      width: 100%;
    }
  }
</style>
